var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ProductLabels"},_vm._l((_vm.labels),function(label,index){return _c('span',{key:index,staticClass:"ProductLabel"},[_c('img',{attrs:{"src":label.pictogram,"alt":label.name}}),(index === _vm.labels.length - 1)?_c('span',[_vm._v(_vm._s(label.name))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }